import { TextField } from "@mui/material";

interface UserRoleNameFieldProps {
    name: string;
    defaultValue: string;
    placeholder: string;
    onRoleNameChange: (name: string) => void;
}

const UserRoleNameField = ({
    name,
    defaultValue,
    placeholder,
    onRoleNameChange,
}: UserRoleNameFieldProps) => {
    return (
        <TextField
            required
            id="userRoleName"
            data-testid="user-role-name-field"
            name={name}
            placeholder={placeholder}
            onChange={(event) => {
                onRoleNameChange(event.target.value);
            }}
            defaultValue={defaultValue}
        />
    );
};

export default UserRoleNameField;
